var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('nuxt'),_vm._v(" "),_c('v-footer',{attrs:{"app":""}},[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+" The Ippy Dippy")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }